// Action Types
export const TAGS_ACTION_TYPES = {
  SET_TAGS_DATA: "SET_TAGS_DATA",
  UPDATE_TAG_CHILDREN: "UPDATE_TAG_CHILDREN",
  SET_ERROR: "SET_ERROR",
};

export const setTagsData = (tags) => ({
  type: TAGS_ACTION_TYPES.SET_TAGS_DATA,
  payload: tags,
});

export const updateTagChildren = (tagId, children) => ({
  type: TAGS_ACTION_TYPES.UPDATE_TAG_CHILDREN,
  payload: { tagId, children },
});

export const setError = (error) => ({
  type: TAGS_ACTION_TYPES.SET_ERROR,
  payload: error,
});
